<template>
  <div class="zhanwei3"></div>

  <div class="top-action-bar">
    <router-link to="">
      <el-button class="back-btn" @click="$router.back(-1)">
        {{ $t("List.button1") }}
      </el-button>
    </router-link>
    <router-link :to="'/'">
      <el-button class="home-btn" type="primary" plain>
        {{ $t("List.button2") }}
      </el-button>
    </router-link>
  </div>
  <div class="zhanwei3"></div>
  <div class="list-tabs-container">
    <el-tabs :tab-position="tabPosition" class="modern-tabs">
      <el-tab-pane :label="$t('List.creationList')">
        <div class="game-list-wrapper">
          <div
            class="game-card animate-card"
            v-for="(item, index) in gameList"
            :key="index"
          >
            <div class="game_left">
              <el-image :src="item.gameCover" fit="cover" class="cover-img">
                <template #placeholder>
                  <div class="image-slot-placeholder">加载中...</div>
                </template>
              </el-image>
            </div>

            <div class="game_center">
              <h3 class="game-title">{{ item.gameTitle || "未命名游戏" }}</h3>

              <div class="meta-tags">
                <el-tag
                  size="small"
                  type="info"
                  effect="plain"
                  class="meta-tag-id"
                >
                  ID: {{ item.id }}
                </el-tag>
                <el-tag
                  size="small"
                  type="success"
                  effect="light"
                  v-if="item.gameLanguage"
                >
                  {{ item.gameLanguage }}
                </el-tag>
                <span class="region-span">不限地区 — 任何地点</span>
              </div>

              <p class="create-time">建立于：{{ item.createTime }}</p>

              <p class="game-desc">
                {{ item.gameDesc ? item.gameDesc.trim() : "暂无详细描述..." }}
              </p>
            </div>

            <div class="game_right">
              <div class="update-tip-box">
                <p v-if="item.updateTime" class="update-time">
                  {{ $t("List.tip") }}{{ item.updateTime }}
                </p>
              </div>
              <div class="btn-group">
                <el-button
                  type="primary"
                  size="default"
                  class="action-btn edit-btn"
                  @click="editGame(item.id)"
                >
                  {{ $t("List.button3") }}
                </el-button>
                <el-button
                  type="danger"
                  plain
                  size="default"
                  class="action-btn delete-btn"
                  @click="deleteGame(item.id)"
                >
                  {{ $t("List.button4") }}
                </el-button>
              </div>
            </div>
          </div>
        </div>

        <div class="zhanwei3"></div>
        <div class="page-pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="gamesTotal"
            @current-change="handleCurrentChange"
          />
        </div>
      </el-tab-pane>

      <el-tab-pane :label="$t('List.trashCan')">
        <div class="game-list-wrapper">
          <div
            class="game-card junk-card"
            v-for="(item, index) in junkGameList"
            :key="index"
          >
            <div class="game_left">
              <el-image :src="item.gameCover" fit="cover" class="cover-img" />
            </div>

            <div class="game_center">
              <h3 class="game-title">{{ item.gameTitle || "未命名游戏" }}</h3>

              <div class="meta-tags">
                <el-tag
                  size="small"
                  type="info"
                  effect="plain"
                  class="meta-tag-id"
                >
                  ID: {{ item.id }}
                </el-tag>
                <el-tag
                  size="small"
                  type="success"
                  effect="light"
                  v-if="item.gameLanguage"
                >
                  {{ item.gameLanguage }}
                </el-tag>
                <span class="region-span">不限地区 — 任何地点</span>
              </div>

              <p class="create-time">建立于：{{ item.createTime }}</p>
              <p class="game-desc">
                {{ item.gameDesc ? item.gameDesc.trim() : "暂无详细描述..." }}
              </p>
            </div>

            <div class="game_right">
              <div class="update-tip-box">
                <p v-if="item.deleteTime" class="days-left">
                  剩余保留：<span class="highlight-days">{{
                    getDaysDifference(item.deleteTime)
                  }}</span>
                  天
                </p>
              </div>
              <div class="btn-group">
                <el-button
                  type="success"
                  size="default"
                  class="action-btn restore-btn"
                  @click="restore(item.id)"
                >
                  还原
                </el-button>
                <el-button
                  type="danger"
                  plain
                  size="default"
                  class="action-btn hard-delete-btn"
                  @click="completeDelete(item.id)"
                >
                  {{ $t("List.button4") }}
                </el-button>
              </div>
            </div>
          </div>
        </div>

        <div class="zhanwei3"></div>
        <div class="page-pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="junkGameListTotal"
            @current-change="handleCurrentChange2"
          />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
  <div class="zhanwei3"></div>
</template>

<script lang="ts">
import { defineComponent, markRaw } from "vue";
import { Game } from "@/views/view";
import { ElMessage, ElMessageBox } from "element-plus";
import { Delete } from "@element-plus/icons-vue";

export default defineComponent({
  name: "gameList",
  data(): any {
    return {
      currentPage: 1,
      currentPage2: 1,
      tabPosition: "left",
      junkGameListTotal: 1,
      junkGameList: [],
    };
  },
  computed: {
    gameList(): Array<Game> {
      return this.$store.state.game.games;
    },
    gamesTotal() {
      return this.$store.state.game.total;
    },
  },
  created() {
    this.fetchGameList(this.currentPage);
    this.fetchJunkGameList(this.currentPage2);
  },
  methods: {
    handleCurrentChange(val: number) {
      this.currentPage = val;
      this.fetchGameList(val);
    },
    handleCurrentChange2(val: number) {
      this.currentPage2 = val;
      this.fetchJunkGameList(val);
    },
    fetchGameList(pageNum: number) {
      const userId = this.$store.state.user.Id;
      const pageSize = 10;
      const status = 0;

      this.$store
        .dispatch("game/getGameList", { pageNum, pageSize, userId, status })
        .catch((err: any) => {
          console.error(err);
        });
    },
    fetchJunkGameList(pageNum: number) {
      const userId = this.$store.state.user.Id;
      const pageSize = 10;
      const status = 0;

      this.$store
        .dispatch("game/getJunkGameList", { pageNum, pageSize, userId, status })
        .then((res: any) => {
          this.junkGameListTotal = res.total;
          this.junkGameList = res.records;
        })
        .catch((err: any) => {
          console.error(err);
        });
    },
    getDaysDifference(endDate: any) {
      const start: any = new Date();
      const end: any = new Date(endDate);
      const timeDiff = end - start;
      const diffInDays = timeDiff / (1000 * 60 * 60 * 24);
      return Math.round(diffInDays);
    },
    editGame(id: string) {
      this.$router.push("/edit/" + id + "/cover");
    },
    restore(id: string) {
      this.$store
        .dispatch("game/restoreGame", { id: id })
        .then(() => {
          this.$message.success("还原成功");
          this.fetchGameList(this.currentPage);
          this.fetchJunkGameList(this.currentPage2);
        })
        .catch(() => {});
    },
    deleteGame(id: string) {
      ElMessageBox.confirm(this.$t("List.deleteInfo"), "警告", {
        type: "warning",
        icon: markRaw(Delete),
        confirmButtonText: this.$t("List.confirm"),
        cancelButtonText: this.$t("List.channel"),
        draggable: true,
      })
        .then(() => {
          this.$store
            .dispatch("game/delGame", { ids: [id] })
            .then((res: any) => {
              if (res == 1) {
                this.$message.success("已移动至垃圾桶");
                this.fetchGameList(this.currentPage);
                this.fetchJunkGameList(this.currentPage2);
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    completeDelete(id: string) {
      ElMessageBox.confirm(
        "确定彻底删除该导览数据吗？此操作无法恢复！",
        "高危警告",
        {
          type: "warning",
          icon: markRaw(Delete),
          confirmButtonText: "彻底删除",
          cancelButtonText: this.$t("List.channel"),
          draggable: true,
        }
      )
        .then(() => {
          this.$store
            .dispatch("game/completeGame", { id: id })
            .then((res: any) => {
              if (res == 1) {
                this.$message.success("数据已彻底清除");
                this.fetchJunkGameList(this.currentPage2);
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
  },
});
</script>

<style lang="less" scoped>
// 基础设计变量
@primary-color: #5d5fef;
@primary-light: #f0f2ff;
@text-main: #1e293b;
@text-sub: #64748b;
@text-muted: #94a3b8;
@border-color: #e2e8f0;
@card-border: #f1f5f9;
@danger-color: #ef4444;
@success-color: #10b981;

/* 占位间距微调 */
.zhanwei3 {
  height: 20px;
}

/* 顶栏控制 */
.top-action-bar {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 24px;

  a {
    text-decoration: none;
  }

  .back-btn {
    border-radius: 8px;
    border-color: @border-color;
    color: @text-sub;
    font-weight: 500;
    transition: all 0.2s ease;

    &:hover {
      background: #f8fafc;
      color: @text-main;
      border-color: #cbd5e1;
    }
  }

  .home-btn {
    border-radius: 8px;
    font-weight: 500;
    background-color: @primary-light;
    border-color: #dce2ff;
    color: @primary-color;
    transition: all 0.2s ease;

    &:hover {
      background-color: @primary-color;
      border-color: @primary-color;
      color: #ffffff;
    }
  }
}

/* 选项卡大容器 */
.list-tabs-container {
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 24px;
  box-sizing: border-box;

  :deep(.modern-tabs) {
    .el-tabs__header {
      margin-right: 36px;
      border-right: 1px solid @border-color;
    }

    .el-tabs__item {
      font-size: 14px;
      font-weight: 600;
      height: 48px;
      line-height: 48px;
      color: @text-sub;
      padding: 0 20px !important;
      transition: all 0.25s ease;

      &:hover {
        color: @primary-color;
      }

      &.is-active {
        color: @primary-color;
        font-weight: 700;
      }
    }

    .el-tabs__active-bar {
      background-color: @primary-color;
      width: 3px;
      border-radius: 2px;
    }
  }
}

/* 列表卡片集合 */
.game-list-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* 核心卡片容器设计 */
.game-card {
  display: flex;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid @card-border;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
  padding: 18px 20px;
  box-sizing: border-box;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  align-items: center;

  &:hover {
    border-color: #e2e8f0;
    transform: translateY(-3px);
    box-shadow: 0 12px 24px -4px rgba(15, 23, 42, 0.06),
      0 4px 6px -2px rgba(15, 23, 42, 0.03);
  }

  /* 封面图 */
  .game_left {
    width: 170px;
    height: 110px;
    border-radius: 8px;
    overflow: hidden;
    flex-shrink: 0;
    background: #f1f5f9;
    position: relative;

    .cover-img {
      width: 100%;
      height: 100%;
      display: block;
      transition: transform 0.3s ease;
    }

    &:hover .cover-img {
      transform: scale(1.04);
    }

    .image-slot-placeholder {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      font-size: 12px;
      color: @text-muted;
      background: #f8fafc;
    }
  }

  /* 中间内容区域 */
  .game_center {
    flex: 1;
    padding: 0 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;

    .game-title {
      margin: 0 0 8px 0;
      font-size: 16px;
      font-weight: 700;
      color: @text-main;
      line-height: 1.4;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .meta-tags {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 8px;
      flex-wrap: wrap;

      .meta-tag-id {
        border-radius: 4px;
        background: #f8fafc;
        border-color: @border-color;
        color: @text-sub;
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
          monospace;
      }

      .region-span {
        font-size: 12px;
        color: @text-muted;
        display: inline-flex;
        align-items: center;

        &::before {
          content: "•";
          margin-right: 6px;
          color: #cbd5e1;
        }
      }
    }

    .create-time {
      margin: 0 0 6px 0;
      font-size: 12px;
      color: @text-muted;
    }

    .game-desc {
      margin: 0;
      font-size: 13px;
      color: @text-sub;
      line-height: 1.6;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }

  /* 右侧操作栏 */
  .game_right {
    width: 170px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    height: 110px;
    flex-shrink: 0;
    box-sizing: border-box;

    .update-tip-box {
      font-size: 12px;
      text-align: right;

      .update-time {
        margin: 0;
        color: @text-muted;
      }

      .days-left {
        margin: 0;
        color: @danger-color;
        font-size: 12px;
        font-weight: 500;
        background: #fef2f2;
        padding: 3px 8px;
        border-radius: 4px;

        .highlight-days {
          font-size: 14px;
          font-weight: 700;
        }
      }
    }

    .btn-group {
      display: flex;
      gap: 8px;
      width: 100%;
      justify-content: flex-end;

      .action-btn {
        min-width: 64px;
        height: 32px;
        padding: 0 12px;
        font-size: 13px;
        font-weight: 500;
        border-radius: 6px;
        transition: all 0.2s ease;
      }

      .edit-btn {
        background-color: @primary-color;
        border-color: @primary-color;

        &:hover {
          background-color: #4b4de0;
          border-color: #4b4de0;
          box-shadow: 0 4px 10px rgba(93, 95, 239, 0.25);
        }
      }

      .delete-btn {
        &:hover {
          background: #fef2f2;
          border-color: #fca5a5;
        }
      }

      .restore-btn {
        background-color: @success-color;
        border-color: @success-color;

        &:hover {
          background-color: #059669;
          border-color: #059669;
        }
      }

      .hard-delete-btn {
        border-color: #fecaca;
        color: @danger-color;

        &:hover {
          background-color: @danger-color;
          border-color: @danger-color;
          color: #ffffff;
        }
      }
    }
  }
}

/* 分页模块美化 */
.page-pagination {
  display: flex;
  justify-content: center;
  margin: 32px 0;

  :deep(.el-pagination.is-background) {
    .el-pager li:not(.is-disabled).is-active {
      background-color: @primary-color;
      font-weight: 600;
    }

    .el-pager li,
    button {
      border-radius: 6px;
      background-color: #f1f5f9;
      color: @text-sub;
      font-weight: 500;

      &:hover {
        color: @primary-color;
      }
    }
  }
}
</style>
